/* Joeba country map: city-markers met Nominatim-geocode (countrycode bias),
   gecached in localStorage. Verwacht globals __joebaContinentMap en __joebaCountryA2. */
(function(){
  function start(){
    var map = window.__joebaContinentMap;
    if (!window.L || !map) { return setTimeout(start, 400); }
    var currentA2 = (window.__joebaCountryA2||'').toUpperCase();
    var tiles = document.querySelectorAll('[data-jb-library-tile]');
    if (!tiles.length) return;
    var cities = [], seen = {};
    tiles.forEach(function(t){
      var name = (t.getAttribute('data-city-name')||'').trim();
      var handle = (t.getAttribute('data-city-handle')||'').trim();
      if (!name || seen[handle]) return;
      seen[handle] = 1;
      cities.push({name:name, handle:handle});
    });
    if (!cities.length) return;
    var country = '';
    var titleEl = document.querySelector('.joeba-country-hero__title');
    if (titleEl) country = (titleEl.textContent||'').trim();
    var CK = 'joeba_city_geo_v3:' + (currentA2||'xx');
    var cache = {};
    try { cache = JSON.parse(localStorage.getItem(CK)||'{}'); } catch(e){ cache = {}; }
    var cityMarkers = L.layerGroup().addTo(map);
    function addMarker(city, lat, lng){
      var label = city.name.replace(/^./, function(c){return c.toUpperCase();});
      var icon = L.divIcon({
        className:'joeba-city-marker',
        html:'<div style="position:relative;transform:translate(-50%,-100%);"><div style="background:#FFDE59;border:2px solid #0e1b4d;width:14px;height:14px;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,.35);margin:0 auto"></div><div style="margin-top:3px;background:#0e1b4d;color:#fff;font-size:11px;font-weight:700;padding:2px 7px;border-radius:999px;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.25)">'+label+'</div></div>',
        iconSize:[1,1], iconAnchor:[0,0]
      });
      var m = L.marker([lat,lng], {icon:icon, riseOnHover:true}).addTo(cityMarkers);
      m.on('click', function(){ var h='#stad-'+city.handle; try{location.hash=h;}catch(_){location.href=location.pathname+h;} });
    }
    function geocode(city){
      var key = city.handle;
      if (cache[key] && cache[key].lat) return Promise.resolve(cache[key]);
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=0&city='+encodeURIComponent(city.name)
        + (currentA2 ? '&countrycodes='+currentA2.toLowerCase() : '')
        + (country ? '&country='+encodeURIComponent(country) : '');
      return fetch(url, {headers:{'Accept-Language':'nl'}}).then(function(r){return r.json();}).then(function(d){
        if (d && d[0]) {
          var v = {lat:parseFloat(d[0].lat), lng:parseFloat(d[0].lon)};
          cache[key] = v;
          try { localStorage.setItem(CK, JSON.stringify(cache)); } catch(e){}
          return v;
        }
        return null;
      }).catch(function(){ return null; });
    }
    var i = 0;
    function next(){
      if (i >= cities.length) return;
      var c = cities[i++];
      var fromCache = !!(cache[c.handle] && cache[c.handle].lat);
      geocode(c).then(function(pos){
        if (pos) addMarker(c, pos.lat, pos.lng);
        setTimeout(next, fromCache ? 30 : 1100);
      });
    }
    next();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(start, 600); });
  } else { setTimeout(start, 600); }
})();
